import { Pressable, View, ActivityIndicator } from "react-native"
import { router } from "expo-router"
import { SafeAreaView } from "react-native-safe-area-context"

import { Text, MCIcon, Header, List } from "@src/components"
import { Alert } from "@src/components/ui/confirm"
import { trpc, sharedStyles } from "@src/utils"
import { ar } from "@src/i18n"

export default function NotificationGroups() {
  const utils = trpc.useUtils()
  const groups = trpc.notifications.groups.list.useQuery()
  const deleteGroup = trpc.notifications.groups.delete.useMutation()

  function handleDelete(id: number) {
    Alert.alert(ar.delete, ar.notificationDeleteGroupConfirmation, [
      { text: ar.cancel, style: "cancel" },
      {
        text: ar.delete,
        style: "destructive",
        onPress: async () => {
          await deleteGroup.mutateAsync(
            { id },
            {
              onSuccess: () => {
                void utils.notifications.groups.list.invalidate()
              },
              onError: (e) => Alert.alert(ar.error, e.message),
            },
          )
        },
      },
    ])
  }

  const headerRight = (
    <Pressable onPress={() => router.push("/dashboard/notifications/groups/new")} className="justify-center px-2 h-full active:opacity-70">
      <MCIcon name="plus" size={25} color="blue" />
    </Pressable>
  )

  if (groups.isLoading) {
    return (
      <>
        <Header title={ar.notificationGroups} right={headerRight} />
        <ActivityIndicator className="mt-2" />
      </>
    )
  }

  return (
    <>
      <Header title={ar.notificationGroups} right={headerRight} />

      <List
        contentContainerStyle={sharedStyles.contentContainer}
        data={groups.data ?? []}
        keyExtractor={(item) => item.id.toString()}
        onRefresh={groups.refetch}
        ListEmptyComponent={<Text className="text-gray-500 text-center py-8">{ar.notificationNoGroups}</Text>}
        renderItem={({ item }) => (
          <View className="bg-white rounded-xl border border-gray-100 p-3.5 mb-2 shadow-sm flex-row items-center justify-between">
            <Pressable className="flex-1" onPress={() => router.push(`/dashboard/notifications/groups/${item.id}`)} disabled={deleteGroup.isPending}>
              <Text className="text-base text-gray-900 font-bold">{item.name}</Text>
              <Text className="text-xs text-gray-500 mt-0.5">
                {ar.notificationGroupMembers}: {item.memberCount}
              </Text>
            </Pressable>
            <View className="flex-row gap-1">
              <Pressable onPress={() => router.push(`/dashboard/notifications/groups/${item.id}`)} className="p-2">
                <MCIcon name="pencil" size={18} color="#3B82F6" />
              </Pressable>
              <Pressable onPress={() => handleDelete(item.id)} className="p-2">
                <MCIcon name="delete" size={18} color="#EF4444" />
              </Pressable>
            </View>
          </View>
        )}
        ListFooterComponent={<SafeAreaView edges={["bottom"]} />}
      />
    </>
  )
}
